export const PAGINATION = {
  page: 1,
  total: 0,
  rowsPerPage: 20,
};

export const SUB_PAGINATION = {
  page: 1,
  total: 0,
  rowsPerPage: 10,
};

export const PAGE_ITEMS = [10, 20, 50, 100];

export const INNER_PAGE_ROWS_PER_PAGE = 10;
import { ref } from "vue";

export function usePagination() {
  const page = ref(1);
  const total = ref(0);
  const rowsPerPage = ref(20);
  return { page, total, rowsPerPage };
}
